'use client'

import { useEffect, useState } from 'react'

export function VersionFooter() {
  const [highlightIdx, setHighlightIdx] = useState(-1)
  const [isRed, setIsRed] = useState(false)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
    const count = parseInt(localStorage.getItem('sassu_load_count') || '0') + 1
    localStorage.setItem('sassu_load_count', String(count))
    setHighlightIdx(Math.floor(Math.random() * 5))
    setIsRed(count % 10 === 0)
  }, [])

  if (!mounted) return null

  const letters = ['s', 'a', 's', 's', 'u']

  return (
    <div className="fixed bottom-0 left-0 w-20 z-50 flex justify-center pb-3 pointer-events-none">
      <span title="Copyright by Sassu" style={{
        fontFamily: 'ui-monospace, monospace',
        fontSize: '11px',
        letterSpacing: '0.1em',
        userSelect: 'none',
        color: '#b0b0b0',
      }}>
        {letters.map((l, i) => (
          <span key={i} style={{
            color: i === highlightIdx ? (isRed ? '#e63946' : '#3a3a3a') : '#b0b0b0',
            fontWeight: i === highlightIdx && !isRed ? 600 : 400,
          }}>{l}</span>
        ))}
      </span>
    </div>
  )
}

export function CompactVersionFooter() {
  return <VersionFooter />
}
